import { ref, computed } from 'vue'

// Глобальний стан гайду встановлення PWA на iOS.
// Дозволяє відкрити анімований гайд з будь-якої точки (баннер, панель довідки).

const isGuideOpen = ref(false)
// true = запущено вручну з довідки (не враховувати в лічильнику показів)
const isManualLaunch = ref(false)

// Визначення середовища
export const isIOS = () => {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) return true
  // iPad на iOS 13+ маскується під Mac
  return ua.includes('mac') && 'ontouchend' in document && navigator.maxTouchPoints > 1
}

export const isSafariOnIOS = () => {
  if (!isIOS()) return false
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.includes('safari') &&
    !ua.includes('crios') &&
    !ua.includes('fxios') &&
    !ua.includes('edgios') &&
    !ua.includes('opios') &&
    !ua.includes('opiios')
}

export const isStandalone = () => {
  if (typeof window === 'undefined') return false
  // Нативна оболонка (застосунок com.cloudGPS.client) — це вже встановлений
  // застосунок, просто без ознак PWA. Без цієї перевірки портал усередині
  // застосунку пропонує «додати на головний екран» тому, хто його вже поставив.
  // Один прапорець тут гасить і банер, і iOS-підказку, і кнопку установки.
  if (window.__CGPS_NATIVE__) return true
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
}

export function useIosInstallGuide() {
  const openGuide = (manual = false) => {
    isManualLaunch.value = manual
    isGuideOpen.value = true
  }

  const closeGuide = () => {
    isGuideOpen.value = false
    isManualLaunch.value = false
  }

  return {
    isGuideOpen: computed(() => isGuideOpen.value),
    isManualLaunch: computed(() => isManualLaunch.value),
    openGuide,
    closeGuide,
  }
}
